(function ($) {
    $(document).ready(function () {
        function checkCarouselBtn() {
            $('.collection-text__head__nav .carousel-btn').each(function() {
                const dataDirection = $(this).attr('data-direction');
                const sliderBtn = $(this).closest('.collection-text').find(`.slider-grid .carousel-btn[data-direction="${dataDirection}"]`);
                if ($(sliderBtn).is('[disabled]')) {
                    $(this).prop('disabled', true);
                } else {
                    $(this).prop('disabled', false);
                }
            });
        }

        setTimeout(function() {
            checkCarouselBtn();
        },1000)

        $(document).on('click', '.collection-text__head__nav .carousel-btn', function() {
            const dataDirection = $(this).attr('data-direction');
            const sliderBtn = $(this).closest('.collection-text').find(`.slider-grid .carousel-btn[data-direction="${dataDirection}"]`);
            $(sliderBtn).trigger('click');

            setTimeout(function() {
                checkCarouselBtn();
            },100)
        });
    });
})(jQuery);